<template>
    <div class="footer">

        <div class="footer-box">

            <div class="link cf">
                <div class="fl">友情链接：</div>
                <div
                    class="fl"
                    v-for="(item,index) in linkList"
                    :key="'link-item-'+index"
                    @click="openLink(item)"
                >
                    {{item.name}}<span v-if="index != linkList.length - 1">|</span>
                </div>
            </div>

            <div class="footer-bottom cf">

                <img class="fl logo-img" src="../../assets/images/logo.png"/>

                <div class="fl">

                    <div class="footer-list">

                        <span
                            v-for="(item,index) in list"
                            :key="'footer-span-'+index"
                            @click="openPage(item)"
                        >
                            {{item.name}}
                        </span>

                    </div>

                    <div class="footer-bottom-text cf">

                        <div class="footer-name fl">长沙南娱笔芯文化传媒有限公司 Copyright ©2020 All Rights Reserved</div>

                        <div class="footer-police fl cf">

                            <img class="fl" src="../../assets/images/police.png">

                            <span class="fl pointer" @click="goPage">湘ICP备18006737号-2</span>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "footerView",
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
